// One naming rule for the join flow and Setup microphones: capitals and spaces never make a new
// singer, a free one is reused rather than duplicated, and one singing elsewhere is never reused.
export const sameSingerName = (a: string, b: string) => a.trim().toLowerCase() === b.trim().toLowerCase();

export type NameCheck<T> =
  | { status: 'empty' }
  | { status: 'new'; name: string }
  | { status: 'existing'; match: T }
  | { status: 'taken'; match: T };

export const checkSingerName = <T extends { name: string; taken: boolean }>(
  draft: string,
  singers: T[],
): NameCheck<T> => {
  const name = draft.trim();
  if (!name) return { status: 'empty' };

  const match = singers.find((singer) => sameSingerName(singer.name, name));
  if (!match) return { status: 'new', name };

  return match.taken ? { status: 'taken', match } : { status: 'existing', match };
};
